const $body = document.querySelector('body')

export const lockMainScroll = (): void => {
  $body.style.overflow = 'hidden'
}
export const unlockMainScroll = (): void => {
  $body.style.removeProperty('overflow')
}
